import React from 'react'
import { observer, makeAutoObservable } from '@/hooks/storeHooks'
import { Loading } from '@/components'
import st from './index.scss'
import cn from 'classnames'


class LoadingStore {
    // 弹框列表
    showLoading = null

    constructor() {
        makeAutoObservable(this)
    }

    setShowLoading(status) {
        this.showLoading = status
    }
}

const store = new LoadingStore()

// 弹框方法
export function show() {
    store.setShowLoading(true)
}

// 移除弹框
export function hide() {
    store.setShowLoading(false)
}

// 弹框容器
export default observer(function CenterLoading() {
    if (!store.showLoading) return null

    return (
        <div className={cn(st['loading'])}>
            <Loading style={{ width: '100px', height: '100px' }} />
        </div>
    )
})
